import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/IBMa/ibm.com-able-v2/able-site/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { withPrefix } from "gatsby";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h4><strong parentName="h4">{`Level 1`}</strong></h4>
    <ul>
      <li parentName="ul"><a href={withPrefix("toolkit/design/ux/#input-components")} target="_blank" rel="noopener noreferrer">Input components</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/visual/#required-fields")} target="_blank" rel="noopener noreferrer">Required fields</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/content#input-labels")} target="_blank" rel="noopener noreferrer">Input labels</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/content#headings")} target="_blank" rel="noopener noreferrer">Headings</a></li>
    </ul>
    <h4><strong parentName="h4">{`Level 2`}</strong></h4>
    <ul>
      <li parentName="ul"><a href={withPrefix("toolkit/design/visual/#data-tables")} target="_blank" rel="noopener noreferrer">Data tables</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/visual/#text-styles")} target="_blank" rel="noopener noreferrer">Text styles</a></li>
    </ul>
    <h4><strong parentName="h4">{`Level 3`}</strong></h4>
    <ul>
      <li parentName="ul"><a href={withPrefix("toolkit/design/content#figure-and-table-captions")} target="_blank" rel="noopener noreferrer">Figure and table captions</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/visual/#form-inputs")} target="_blank" rel="noopener noreferrer">Form inputs</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/visual/#regions")} target="_blank" rel="noopener noreferrer">Regions</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/visual/#white-space")} target="_blank" rel="noopener noreferrer">White space</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      